module.exports = __webpack_public_path__ + "static/media/IUCA Logo.65de64d0.jpeg";